import React from 'react';
import { Link } from 'react-router-dom';
import { TwitterIcon, LinkedinIcon, GithubIcon, MailIcon, MapPinIcon, CheckCircleIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-[#0F1115] text-gray-400 border-t border-gray-800" data-id="element-56">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-57">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-58">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-59">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-60">
              <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center shadow-lg" data-id="element-61">
                <CheckCircleIcon className="w-5 h-5 text-[#d73b3e]" data-id="element-62" />
              </div>
              <span className="font-display font-bold text-xl text-white tracking-tight" data-id="element-63">
                Certified<span className="text-[#d73b3e]" data-id="element-64">Devs</span>
              </span>
            </Link>
            <p className="text-sm mb-4" data-id="element-65">
              Connecting certified developers with top companies worldwide.
            </p>
            <div className="flex gap-4" data-id="element-66">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-67">
                <TwitterIcon className="w-5 h-5" data-id="element-68" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-69">
                <LinkedinIcon className="w-5 h-5" data-id="element-70" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-71">
                <GithubIcon className="w-5 h-5" data-id="element-72" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-73">
            <h3 className="text-white font-semibold mb-4" data-id="element-74">For Developers</h3>
            <ul className="space-y-2 text-sm" data-id="element-75">
              <li data-id="element-76">
                <Link to="/jobs" className="hover:text-white transition-colors" data-id="element-77">
                  Browse Jobs
                </Link>
              </li>
              <li data-id="element-78">
                <Link to="/signup" className="hover:text-white transition-colors" data-id="element-79">
                  Get Certified
                </Link>
              </li>
              <li data-id="element-80">
                <Link to="/developer/login" className="hover:text-white transition-colors" data-id="element-81">
                  Developer Login
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-82">
            <h3 className="text-white font-semibold mb-4" data-id="element-83">For Companies</h3>
            <ul className="space-y-2 text-sm" data-id="element-84">
              <li data-id="element-85">
                <Link to="/developers" className="hover:text-white transition-colors" data-id="element-86">
                  Browse Talent
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/post-job" className="hover:text-white transition-colors" data-id="element-88">
                  Post a Job
                </Link>
              </li>
              <li data-id="element-89">
                <Link to="/pricing" className="hover:text-white transition-colors" data-id="element-90">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-91">
            <h3 className="text-white font-semibold mb-4" data-id="element-92">Contact</h3>
            <ul className="space-y-2 text-sm" data-id="element-93">
              <li className="flex items-center gap-2" data-id="element-94">
                <MailIcon className="w-4 h-4" data-id="element-95" />
                <a href="mailto:hello@certifieddevs.com" className="hover:text-white transition-colors" data-id="element-96">
                  hello@certifieddevs.com
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-97">
                <MapPinIcon className="w-4 h-4" data-id="element-98" />
                <span data-id="element-99">Amsterdam, Netherlands</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-100">
          <p data-id="element-101">
            &copy; {new Date().getFullYear()} CertifiedDevs. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-102">
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-103">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-id="element-104">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};